import httpClient from '../config/httpClient';

/**
 * Task History Service for Client-Side Integration
 * This service provides easy-to-use functions for interacting with task history
 */

/**
 * Get task history with pagination support
 * @param {string} taskId - Task ID
 * @param {number} limit - Number of entries to retrieve (default: 20)
 * @param {number} offset - Starting position for pagination (default: 0)
 * @returns {Promise<Object>} History data with pagination info
 */
export const getTaskHistory = async (taskId, limit = 20, offset = 0) => {
  try {
    console.log(
      `Task History: Retrieving history for task ${taskId} (limit: ${limit}, offset: ${offset})`
    );

    const response = await httpClient.get('/getTaskHistory', {
      params: {
        taskId,
        limit,
        offset,
      },
    });

    console.log(
      `Task History: Retrieved ${response.data.history.length} entries (${response.data.totalCount} total) for task ${taskId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      `Task History: Error retrieving history for task ${taskId}:`,
      error
    );
    throw error.response?.data || error;
  }
};

/**
 * Get complete task history (all entries)
 * Use with caution for tasks with extensive history
 * @param {string} taskId - Task ID
 * @returns {Promise<Object>} Complete history data
 */
export const getCompleteTaskHistory = async (taskId) => {
  try {
    console.log(`Task History: Retrieving complete history for task ${taskId}`);

    const response = await httpClient.get('/getCompleteTaskHistory', {
      params: {
        taskId,
      },
    });

    console.log(
      `Task History: Retrieved complete history (${response.data.totalCount} entries) for task ${taskId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      `Task History: Error retrieving complete history for task ${taskId}:`,
      error
    );
    throw error.response?.data || error;
  }
};
